import { fetchBusinessInfo, updateBusinessInfo } from "@/api/providerDashboard";
import {
  mergeProviderBenefits,
  splitProviderBenefits,
} from "@/utils/providerBenefits";

export default {
  async loadInfo() {
    try {
      const res = await fetchBusinessInfo();
      if (res.data.status === 200 && res.data.data) {
        const d = res.data.data;
        this.form.type = d.type || "";
        this.form.comments = d.comments || "";
        this.form.visitNoticesText = (d.visitNotices || []).join("\n");
        this.form.description = d.description || "";
        this.form.phone = d.phone || "";
        this.form.address = d.address || "";
        this.form.detailAddress = d.detailAddress || "";
        this.form.landMark = d.landMark || "";
        this.form.workTime = d.workTime || "";
        this.form.services = Array.from(
          new Set(
            (Array.isArray(d.services) ? d.services : []).map((service) => {
              if (service === "A/S") return "AS";
              if (service === "맞춤제작") return "커스텀제작";
              return service;
            })
          )
        );
        const rawThumbnail =
          typeof d.thumbnail === "string" ? d.thumbnail.trim() : "";
        const normalizedSlides = Array.isArray(d.thumbnailImages)
          ? [
              ...new Set(
                d.thumbnailImages
                  .filter((url) => typeof url === "string" && url.trim())
                  .map((url) => url.trim())
              ),
            ].slice(0, 10)
          : [];
        if (normalizedSlides.length) {
          this.form.thumbnailImages =
            rawThumbnail && normalizedSlides[0] !== rawThumbnail
              ? [
                  rawThumbnail,
                  ...normalizedSlides
                    .slice(1)
                    .filter((url) => url !== rawThumbnail),
                ].slice(0, 10)
              : normalizedSlides;
        } else {
          this.form.thumbnailImages = rawThumbnail ? [rawThumbnail] : [];
        }
        this.form.thumbnail = this.form.thumbnailImages[0] || "";
        this.form.images = d.images || [];
        this.form.amenities = {
          parking: !!(d.amenities && d.amenities.parking),
          privateConsultation: !!(
            d.amenities && d.amenities.privateConsultation
          ),
          oneOnOne: !!(d.amenities && d.amenities.oneOnOne),
        };
        this.form.pricingPolicy = d.pricingPolicy || "";
        const benefits = splitProviderBenefits(d.benefits);
        this.filterBenefits = benefits.filterBenefits;
        this.consultationBenefits = benefits.consultationBenefits;
        this.form.reservationRequired = !!d.reservationRequired;
        this.form.comparisonEstimateEnabled =
          d.comparisonEstimateEnabled !== false;
        this.form.region =
          this.deriveRegionFromAddress(d.address) || d.region || "";
      }
    } catch (err) {
      console.error(err);
    } finally {
      this.loading = false;
    }
  },
  async save() {
    if (this.thumbnailUploading) {
      this.$message.warning("대표 사진 업로드가 끝난 뒤 저장해 주세요.");
      return;
    }
    try {
      const payload = {
        ...this.form,
        thumbnail: this.form.thumbnailImages[0] || "",
        visitNotices: this.form.visitNoticesText
          .split(/\r?\n/)
          .map((line) => line.trim())
          .filter(Boolean),
        benefits: mergeProviderBenefits(
          this.filterBenefits,
          this.consultationBenefits
        ),
      };
      delete payload.type;
      delete payload.visitNoticesText;
      delete payload.workTime;
      delete payload.comparisonEstimateEnabled;
      delete payload.comparisonEstimateReceivingHours;
      const res = await updateBusinessInfo(payload);
      if (res.data.status === 200) {
        this.$message.success("저장되었습니다.");
      } else {
        this.$alert(res.data.message || "저장 실패");
      }
    } catch (err) {
      this.$alert(
        (err &&
          err.response &&
          err.response.data &&
          err.response.data.message) ||
          "저장 실패"
      );
    }
  },
};
